<template>
  <div class="lp-container">
    <div class="lps-failed">
      <div class="failed_title">
        {{ $t('Payment Failed') }}
      </div>
      <img
        src="../../assets/images/lps/payment-failed.png"
        class="1-100"
      >
      <h3 class="mt-3">
        {{ $t('Oho no') }}...
      </h3>
      <p class="mt-05 text-center">
        {{ $t('Your transaction could not be completed due to a problem with your bank. Do you want to try again?') }}
      </p>
      <router-link
        v-if="tryRouteName"
        :to="{name: tryRouteName}"
      >
        <b-button
          class="mt-1 w-100"
          type="submit"
          variant="primary"
          style="background-color: #AC33F4 !important; color: #fff !important; padding: 18px; border-radius: 16px; text-align: center"
          block
        >
          {{ $t('Try Again') }}
        </b-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentFailed',
  data() {
    return {
      tryRouteName: null,
    }
  },
  created() {
    this.tryRouteName = localStorage.getItem('try_route_name') || null
  },
}
</script>

<style scoped lang="scss">
.lps-failed {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 12px;

  .failed_title {
    background-color: #F2D3D3;
    border: 2px solid #E09596;
    padding: 12px;
    text-align: center;
    width: 100%;
    color: #FF5558 !important;
    border-radius: 12px;
    font-size: 22px;
    margin-bottom: 36px;
  }
}
</style>
